import type { IScimToken } from "@performyard/models";
import type { ConvertObjectIdsAndDatesToString, ConvertObjectIdsToString } from "@performyard/utils-isomorphic";

import request from "../base-request";

type RequestResponse<T> = {
	data: T;
	errors: unknown[];
};

type ScimTokenResponseJson = ConvertObjectIdsAndDatesToString<IScimToken>;
type ScimTokenRequest = ConvertObjectIdsToString<IScimToken>;
export type ScimToken = ConvertObjectIdsToString<IScimToken>;

export const getScimTokens = async (column: string, direction: string) => {
	const [response] = await request<RequestResponse<ScimTokenResponseJson[]>>(
		`/scim-token?column=${column}&direction=${direction}`
	);

	return {
		...response,
		data: response.data.map((scimToken) => ({
			...scimToken,
			last_used_at: scimToken.last_used_at ? new Date(scimToken.last_used_at) : null,
		})),
	};
};

export const getScimTokenById = async (id: string): Promise<RequestResponse<ScimTokenResponseJson>> => {
	const [response] = await request<RequestResponse<ScimTokenResponseJson>>(`/scim-token/${id}/`);
	return response;
};

export const createScimToken = async (
	data: Pick<ScimTokenRequest, "name" | "enabled" | "manager_sync_enabled">
): Promise<RequestResponse<ScimTokenResponseJson>> => {
	const [response] = await request<RequestResponse<ScimTokenResponseJson>>("/scim-token", {
		method: "POST",
		body: JSON.stringify(data),
	});

	return response;
};

export const regenerateScimToken = async (
	data: Pick<ScimTokenRequest, "name" | "enabled" | "_id">
): Promise<RequestResponse<ScimTokenResponseJson>> => {
	const [response] = await request<RequestResponse<ScimTokenResponseJson>>(`/scim-token/${data._id}/regenerate`, {
		method: "POST",
		body: JSON.stringify({ name: data.name, enabled: data.enabled }),
	});
	return response;
};

export const deleteScimToken = async (id: string): Promise<void> => {
	await request<{ success: boolean }>(`/scim-token/${id}/`, {
		method: "DELETE",
	});
};

export const updateScimToken = async (
	data: Pick<ScimTokenRequest, "name" | "enabled" | "_id" | "manager_sync_enabled">
): Promise<ScimTokenResponseJson> => {
	const [response] = await request<ConvertObjectIdsAndDatesToString<ScimTokenResponseJson>>(
		`/scim-token/${data._id}/`,
		{
			method: "PATCH",
			body: JSON.stringify({
				name: data.name,
				enabled: data.enabled,
				manager_sync_enabled: data.manager_sync_enabled,
			}),
		}
	);
	return response;
};
